
import { useState } from 'react';

import moment from 'moment';
import API from 'service/api';

import Protected from 'component/Protected';
import PopMessage from 'component/pop-msg/PopMessage';
import DatePicker from 'react-datepicker';

const RecalcBillModal = ({owner, onUpdated, closeModal}) =>
{

  const [sel_rcMonth, setRcMonth]     = useState(new Date());  // reclac start month
  const [sel_condMonth, setCondMonth] = useState(1);           // continuous calc following N months (inclusive)
  const [_bth, toggleRecalc]          = useState(false);

  const removeBills = () =>
  {
    let ix = parseInt(moment(sel_rcMonth).format('YYYYMM'), 10);
    API.deleteOutstandingBills(ix).then(resp => {
      if (!resp.success)
        PopMessage.show(resp.msg, '操作失敗', 'danger');
      else {
        PopMessage.show(resp.msg, '成功', 'success');
        onUpdated();
        closeModal();
      }
    });
  }


  const recalcBills = () =>
  {
    toggleRecalc(true);

    let ix = parseInt(moment(sel_rcMonth).format('YYYYMM'), 10);
    let dto = { count: sel_condMonth };

    let query;
    query = owner
      ? API.recalcCustBills(owner.id, ix, dto)
      : API.recalcAllBills(ix);

    query.then(resp => {
      if (resp.success)
      {
        PopMessage.show(resp.msg, '成功', 'success');
        onUpdated();
        window.setTimeout(() => toggleRecalc(false), 30000);
        closeModal();
      } else {
        PopMessage.show(resp.msg, '連接失敗', 'danger');
      }
    });
  }

  return (
    <>
      <p className="message red">注意，上月結果將影響計算結果。</p>
      <label className="field">
        <strong>結算月份</strong>
        <DatePicker selected={sel_rcMonth} onChange={setRcMonth}
          showMonthYearPicker
          dateFormat="MMM yyyy"
        />
      </label>
      <label className="field">
        <strong>連續</strong>
        <input type="number" min="1" max="12" value={sel_condMonth} onChange={e=>setCondMonth(parseInt(e.target.value, 10))} />
      </label>
      <div className="action-panel">
        <div> { !owner &&
          <Protected allow={['ADMIN']}>
            <button className="btn red" type="button"
              onClick={removeBills}>
                移除所有未付款賬單
              </button>
          </Protected>
        }
        </div>
        <button className="btn red" type="button"
          onClick={recalcBills}
          disabled={_bth}
        >結算
        </button>
      </div>
    </>
  );
}



export default RecalcBillModal;